"use client"

import Link from "next/link"
import { Logo } from "../components/ui/Logo"

export default function Error() {
  return (
    <div className="flex min-h-full flex-col bg-gray-950 pt-16 pb-12">
      <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-6 lg:px-8">
        <div className="flex flex-shrink-0 justify-center">
          <Link
            href="/"
            className="inline-flex items-center justify-center"
            aria-label="Seedmancer home"
          >
            <Logo variant="wordmark" />
          </Link>
        </div>
        <div className="py-16">
          <div className="text-center">
            <p className="text-base font-semibold text-emerald-400">500</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-100 sm:text-5xl">
              Internal Server Error.
            </h1>
            <p className="mt-2 text-base text-gray-400">
              Sorry, we have a trouble. Please try it again later.
            </p>
            <div className="mt-6">
              <Link
                href="/"
                className="text-base font-medium text-emerald-400 hover:text-emerald-300"
              >
                Go back home
                <span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
